var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dce3ndf3da"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.905882 0 0 0 0 0.909804 0 0 0 0 0.913725 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "egfb0c17eb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.333333 0 0 0 0 0.368627 0 0 0 0 0.384314 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#egfb0c17eb)",
    transform: "translate(-1614 -35) translate(1614 35)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.342c0 2.325-2.094 4.162-4.498 3.727-1.717-.31-3.085-2.17-3.085-3.913V7.01c0-1.744 1.368-3.603 3.085-3.913 2.404-.434 4.498 1.402 4.498 3.728v1.517z",
    transform: "translate(5.5 5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.917 12.458c0 6.882-5.578 12.459-12.459 12.459C5.578 24.917 0 19.34 0 12.458 0 5.577 5.578 0 12.458 0s12.459 5.577 12.459 12.458z",
    transform: "translate(5.5 5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.965 21.57c1.387-3.12 4.67-5.32 8.494-5.32s7.106 2.2 8.493 5.32",
    transform: "translate(5.5 5.5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f256a78a1deb34e4662f549d299db163.svg";
export { ForwardRef as ReactComponent };